import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import BillingService from "../../../Services/BillingService";
import Preview from "../../../Assets/Icons/visibility.svg";
import {
  FaChevronLeft,
  FaChevronRight,
  FaFilter,
  FaSearch,
} from "react-icons/fa";
import Layouts from "../../Layouts";
import {
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Row,
  Spin,
} from "antd";
import OrderService from "../../../Services/OrderService";

import moment from "moment";
import BillingPrint from "../Payments/BillingPrint";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import PatientQueue from "../VCPage/PatientQueue";
import Draggable from "react-draggable";
import { IoIosCloseCircle } from "react-icons/io";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import nodatafound from "../../../Assets/Icons/NoDataCard2.svg";

const OrderReport = () => {
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const INITIAL_FILTERS = {
    patientName: "",
    patientId: "",
    serviceTransId: "",
    pageNo: 1,
    userId: loginResultObject?.user.userId,
    clinic_id: loginResultObject?.user.clinic_Id,
    fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
    toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
    statuses: "1,4",
  };
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [hasNextPage, setHasNextPage] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [billModal, setBillModal] = useState(false);
  const [billingRecord, setBillingRecord] = useState({});
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const [formData, setFormData] = useState({
    patientName: "",
    patientId: "",
    serviceTransId: "",
    serviceCode: "",
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData({
      patientName: "",
      patientId: "",
      serviceTransId: "",
    });
  };

  const fetchOrderReports = async () => {
    setLoading(true);
    try {
      const payload = {
        ...filters,
      };

      const res = await OrderService.GetOrderList(payload);
      setList(res.data);
      setHasNextPage(res.data.length == ITEMS_PER_PAGE);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderReports();
  }, [filters]);

  const applyFilter = (updatedValues) => {
    setFilters((prev) => ({
      ...prev,
      ...updatedValues,
    }));
    setIsFilterApplied(true);
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({
      ...prev,
      pageNo: newPage,
    }));
  };

  const clearFilters = () => {
    setFilters(INITIAL_FILTERS);
    setIsFilterApplied(false);
    setFormData({
      patientName: "",
      patientId: "",
      serviceTransId: "",
    });
  };

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      userId: loginResultObject?.user.userId,
      clinic_id: loginResultObject?.user.clinic_Id,
      fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
      toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
    }));
  }, []);

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, hh:mm A") => {
    const localDate = dayjs.utc(utcDate).local();
    return localDate.format(format);
  };

  const handleMonthFilter = (value) => {
    const formattedDate = "01";
    const formattedMonth = value.format("MM");
    const formattedYear = value.format("YYYY");
    const fromDate = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    const fromDateMoment = moment(fromDate, "MM/DD/YYYY");
    const lastDayOfMonth = fromDateMoment.endOf("month").format("MM/DD/YYYY");
    const toDate = lastDayOfMonth;

    setFilters((prev) => ({
      ...prev,
      fromDate: fromDate,
      toDate: toDate,
      pageNo: 1,
    }));
    setIsFilterApplied(true);
  };

  const handleFinish = () => {
    const { patientId, patientName, serviceTransId } = formData;
    if (!patientId && !patientName && !serviceTransId) {
      message.warning("Enter at least one value.");
      return;
    }
    applyFilter({
      patientId: patientId,
      patientName: patientName,
      serviceTransId: serviceTransId,
    });
    setIsModalOpen(false);
  };

  const handleBillingPreview = (record) => {
    if (record.status !== 1) {
      message.error("Payment is not completed");
      return;
    }
    setBillingRecord(record);
    setBillModal(true);
  };
  const closeBillingModal = () => {
    setBillModal(false);
    setBillingRecord({});
  };

  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };
  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };
  return (
    <Layouts>
      <div className="flex flex-col h-full">
        <div className="font-bold">Order Reports</div>

        {/* MOBILE TOOLBAR (hidden on md+) */}
        <div className="flex md:hidden flex-col gap-2 mt-2">
          {/* Row 1: Search */}
          <Input
            className="w-full"
            placeholder="Search Patient"
            value={filters.patientName}
            onChange={(e) => applyFilter({ patientName: e.target.value })}
            suffix={
              <button className="bg-white font-semibold p-1 rounded-md">
                <FaSearch />
              </button>
            }
          />
          {/* Row 2: action buttons */}
          <div className="flex items-center gap-2">
            {isFilterApplied && (
              <button
                onClick={clearFilters}
                className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md flex items-center text-xs flex-1 justify-center"
              >
                Clear
              </button>
            )}
            <DatePicker
              onChange={handleMonthFilter}
              picker="month"
              format="MMM YYYY"
              value={filters.fromDate ? dayjs(filters.fromDate) : null}
              allowClear={false}
              className="h-[38px] flex-1"
            />
            <button
              className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md flex items-center text-xs flex-1 justify-center"
              onClick={showModal}
            >
              <FaFilter className="mr-1" />
              Filter
            </button>
          </div>
        </div>

        {/* DESKTOP TOOLBAR (hidden on mobile) — COMPLETELY UNCHANGED */}
        <div className="hidden md:flex">
          <div className="md:flex justify-end items-center md:w-[60%]">
            <Input
              className="md:w-[60%]"
              placeholder="Search Patient"
              value={filters.patientName}
              onChange={(e) => applyFilter({ patientName: e.target.value })}
              suffix={
                <button className="bg-white font-semibold p-2 rounded-md">
                  <FaSearch />
                </button>
              }
            />
          </div>
          <div className="flex justify-end gap-2 md:w-[40%]">
            {isFilterApplied && (
              <button
                onClick={clearFilters}
                className="text-white bg-brand-primaryColor font-semibold p-2 rounded-md flex items-center"
              >
                Clear Filters
              </button>
            )}
            <div>
              <DatePicker
                onChange={handleMonthFilter}
                picker="month"
                format="MMM YYYY"
                value={filters.fromDate ? dayjs(filters.fromDate) : null}
                allowClear={false}
                className="h-[40px]"
              />
            </div>
            <div className="flex ml-4 items-center justify-end">
              <button
                className="text-white bg-brand-primaryColor font-semibold p-2 rounded-md flex items-center"
                onClick={showModal}
              >
                <FaFilter className="mr-1" />
                Filter
              </button>
            </div>
          </div>
        </div>

        <div className="w-full mt-5 scrollwidth overflow-x-scroll  rounded-md">
          {loading && (
            <div className="h-screen flex items-center justify-center">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          )}

          {!loading && list.length === 0 && (
            <div className="flex flex-col items-center justify-center h-[inherit]">
              <img src={nodatafound} alt="nodatafound" />
              <p className="font-medium text-xl">No Records found!!</p>
            </div>
          )}

          {!loading && list.length > 0 && (
            <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
              <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                <tr className="font-sans font-normal">
                  <th className="p-3 whitespace-nowrap">Patient Name</th>
                  <th className="p-3 whitespace-nowrap">Patient ID</th>
                  <th className="p-3 whitespace-nowrap">Service ID</th>
                  <th className="p-3 whitespace-nowrap">Transaction ID</th>
                  <th className="p-3 whitespace-nowrap">Paid Date</th>
                  <th className="p-3 whitespace-nowrap">Type of Service</th>
                  <th className="p-3 whitespace-nowrap">Mode of Payment</th>
                  <th className="p-3 whitespace-nowrap">Discount Amount</th>
                  <th className="p-3 whitespace-nowrap">Consultation Amount</th>
                  <th className="p-3 whitespace-nowrap">Medicine Amount</th>
                  <th className="p-3 whitespace-nowrap">Pharmacy Name</th>
                  <th className="p-3 whitespace-nowrap">Lab Amount</th>
                  <th className="p-3 whitespace-nowrap">Lab Name</th>
                </tr>
              </thead>
              <tbody>
                {list.map((order, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                  >
                    <td className="p-3 whitespace-nowrap ">
                      {order.patientName}
                    </td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.patientId}
                    </td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.serviceTransId}
                    </td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.transactionId}
                    </td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.paymentDate}
                    </td>
                    <td className="p-3 whitespace-nowrap ">Video</td>
                    <td className="p-3 whitespace-nowrap ">{order.paymode}</td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.discountAmount}
                    </td>
                    <td className="p-3 whitespace-nowrap ">{order.amount}</td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.drugAmount}
                    </td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.pharmacyName}
                    </td>
                    <td className="p-3 whitespace-nowrap ">
                      {order.labAmount}
                    </td>
                    <td className="p-3 whitespace-nowrap ">{order.labName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
          <div className="flex items-center justify-center space-x-2">
            <button
              className={`p-2 rounded-md ${filters.pageNo === 1
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
                }`}
              onClick={() => handlePageChange(filters.pageNo - 1)}
              disabled={filters.pageNo === 1}
            >
              <FaChevronLeft className="text-[#189FAA]" />
            </button>

            {filters.pageNo > 2 && (
              <>
                <button
                  className="px-3 py-1  text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                  onClick={() => handlePageChange(1)}
                >
                  1
                </button>
                {filters.pageNo > 3 && (
                  <span className="text-gray-500">...</span>
                )}
              </>
            )}

            {filters.pageNo > 1 && (
              <button
                className="px-3 py-1  text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                onClick={() => handlePageChange(filters.pageNo - 1)}
              >
                {filters.pageNo - 1}
              </button>
            )}

            <button className="px-3 py-1 rounded-md bg-teal-500 text-white text-sm">
              {filters.pageNo}
            </button>

            {hasNextPage && (
              <button
                className="px-3 py-1  text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                onClick={() => handlePageChange(filters.pageNo + 1)}
              >
                {filters.pageNo + 1}
              </button>
            )}

            <button
              className={`p-2 rounded-md ${!hasNextPage
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
                }`}
              onClick={() => handlePageChange(filters.pageNo + 1)}
              disabled={!hasNextPage}
            >
              <FaChevronRight className="text-[#189FAA]" />
            </button>
          </div>
        </div>
      </div>
      <Modal
        title="Order Reports Filter"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={300}
      >
        <Form className="" name="trigger" layout="vertical">
          <div className="flex flex-col gap-2 my-4">
            <div className="relative mt-4 ">
              <label
                htmlFor="patientname"
                className="absolute -top-3 z-10 left-2 bg-white px-1 "
              >
                Patient Name
              </label>
              <Input
                type="text"
                id="patientname"
                placeholder=""
                name="patientName"
                value={formData.patientName}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </div>

            <div className="relative mt-4 ">
              <label
                htmlFor="patientId"
                className="absolute -top-3 z-10 left-2 bg-white px-1 "
              >
                Patient ID
              </label>
              <Input
                type="text"
                id="patientId"
                placeholder=""
                name="patientId"
                value={formData.patientId}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </div>
            <div className="relative mt-4 ">
              <label
                htmlFor="serviceTransId"
                className="absolute -top-3 z-10 left-2 bg-white px-1 "
              >
                Transaction ID
              </label>
              <Input
                type="text"
                id="serviceTransId"
                name="serviceTransId"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <Form.Item>
            <div className="flex justify-end  mt-3  border-brand-colorBorder gap-3 pt-2">
              <button
                className="h-[32px] Btnwhite rounded-sm w-[82px] border-gray-600 border-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="h-[32px] w-[118px] text-white rounded-sm"
                type="primary"
                onClick={() => handleFinish()}
              >
                Filter
              </button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <div>
        {/* patient queue design */}
        {isVerticalOpen ? (
          <Draggable>
            <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
              <div
                className="hidden md:block relative mb-5 cursor-pointer"
                onClick={closeCircle}
              >
                <IoIosCloseCircle className="hidden md:block absolute text-red-400 mb-1 right-0 top-0" />
              </div>
              <img
                src={patientqueue}
                alt="patientqueue"
                className="cursor-pointer"
                title="Patient Queue"
                onClick={showDrawer}
              />
            </div>
          </Draggable>
        ) : (
          <div
            className="vertical"
            style={{ marginTop: "16rem" }}
            onClick={handleClick}
          >
            <p className="vertical-p">
              <div className="vertical-icon-dashboard">
                <MdKeyboardDoubleArrowUp />
              </div>
              Queue
            </p>
          </div>
        )}

        {isDrawerOpen && (
          <div className="grid justify-end mt-5">
            {isDrawerOpen && <PatientQueue onClose={onClose} />}
          </div>
        )}
        {/* patient queue design end */}

        {billModal && (
          <Modal
            title="Invoice Bill"
            width={1000}
            footer={null}
            open={billModal}
            onCancel={closeBillingModal}
          >
            <BillingPrint
              billingRecord={billingRecord}
              loginResultObject={loginResultObject}
            />
          </Modal>
        )}
      </div>
    </Layouts>
  );
};

export default OrderReport;
